module.exports = __webpack_public_path__ + "static/media/consola.0a517c03.png";